module.exports = __webpack_public_path__ + "static/media/a-pc-bg.3e157f67.png";